import { onError } from '@apollo/client/link/error';

let handler: Parameters<typeof onError>[0];

export function setGraphqlErrorHandler(_handler: typeof handler) {
  handler = _handler;
}

export const ErrorLink = onError((error) => handler?.(error));
